const classPrefix = 'summary-banner'
const dataPrefix = 'data-summary-banner'
const $container = document.querySelector(`[${dataPrefix}]`)
import axios from "axios";

if ($container) {
    summaryBanner({$container})
}

export function summaryBanner({$container}) {

    const $title = document.querySelector(`[${dataPrefix}-title]`)
    const $fill = document.querySelector(`[${dataPrefix}-fill]`)
    const $count = document.querySelector(`[${dataPrefix}-count]`)

    const $reloadBtn = document.querySelector(`[${dataPrefix}-reload-btn]`)
    const $reloadBtnMobile = document.querySelector(`[${dataPrefix}-reload-btn-m]`)
    const $reloadBtnDemo = document.querySelector(`[${dataPrefix}-reload-btn-d]`)



    init();

    function init() {
        if ($reloadBtn) {
            $reloadBtn.addEventListener('click', reloadCourse);
        }
        if ($reloadBtnMobile) {
            $reloadBtnMobile.addEventListener('click', reloadCourse);
        }
        if ($reloadBtnDemo) {
            $reloadBtnDemo.addEventListener('click', reloadCourse);
        }
    }


    function reloadCourse() {
        axios({
            method: 'POST',
            url: '/answers/reload',
            data: {
                video_id: window.currentVideo
            }
        }).then((response) => {
            window.location = '/video/' + window.currentVideo
        }).catch((error) => {
            console.error('Ошибка при перезагрузке курса:', error.response?.data || error.message);
        });
    }

}




